import AppConfig from "AppConfig";

let Auth = {
    loadGoogleAuthApi(callback = () => {}) {
        // First, add meta needed for Google Auth API
        let googleClientId = document.createElement("meta");
        googleClientId.name = "google-signin-client_id";
        googleClientId.content = AppConfig.googleClientId;
        document.head.appendChild(googleClientId);

        // Then, dynamically load Google API
        // Attach a callback function that will be called when the library will be loaded
        window.onLoadGoogleAuthApi = function() {
            window.gapi.load('auth2', function () {
                window.gapi.auth2.init().then(callback);
            });
        };
        let googleApiScript = document.createElement("script");
        googleApiScript.src = `https://apis.google.com/js/platform.js?onload=onLoadGoogleAuthApi`;
        googleApiScript.setAttribute('defer', '');
        googleApiScript.setAttribute('async', '');
        // Catch any exception while loading google script (Firefox private navigation mode is blocking this script)
        googleApiScript.onerror = (error) => { callback(error) };
        document.head.appendChild(googleApiScript);
    },

    loadFacebookAuthApi(callback = () => {}) {
        // Will be asynchronously called when Facebook SDK will be loaded
        window.fbAsyncInit = function() {
            window.FB.init({
                appId      : AppConfig.facebookAppId,
                cookie     : true,
                xfbml      : true,
                version    : `v${AppConfig.facebookApiVersion}`
            });

            callback();
        };

        // Load Facebook SDK
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            // Catch any exception while loading facebook script (Firefox private navigation mode is blocking this script)
            js.onerror = (error) => { callback(error) };
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }
};

export default Auth;


// WEBPACK FOOTER //
// ./js/auth/Auth.js